export enum ROUTESURL {
   LOGIN = "login",
   DECLARATION = "starten",
   SUCCESS = "ende",
   MAINTENANCEWORK = "maintenancework",
   NOTFOUND = 'not-found',
} 